<template>
	
    <div class="corporateInformation-wrapper">
        <h2 class="page-title">{{ $t('ModifyData') }}</h2>
		<el-divider></el-divider>
		  <!-- <a target="_blank" v-if="form.appsecret" :href="url">{{$t('refresh token')}}</a>  -->

          <template v-if="root_management === '1'">
            <el-row :gutter="12">
                <el-col :xs="24" :span="24" :lg="18">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{$t('modifyInformation')}}</span>
                        </div>
                        <el-form :model="form">
                            <el-form-item :label="item.label" v-for="item in formConfig" :key="item.prop" >
                                <el-input v-model="form[item.prop]" clearable readonly="true" :disabled="true"></el-input>
                            </el-form-item>
                        </el-form>
                        <!--<el-button type="primary" @click="changeInfo" class="btn">{{$t('submit')}}</el-button>-->
                        <el-button type="primary" @click="dialogVisible=true" class="btn">{{ $t('edit') }}</el-button>
                    </el-card>
                </el-col>
            </el-row>
            <div style="height: 30px;"></div>
            <el-row :gutter="12">
                <el-col :xs="24" :span="24" :lg="18">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('accessInfo') }}</span>
                        </div>
                        <el-form :model="form">
                            <el-form-item :label="$t('accessAddress')"  >
                                <el-input  v-model="linkurl" clearable readonly="true" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="Token"  >
                                <el-input v-model="linktoken"  clearable readonly="true" :disabled="true"></el-input>
                            </el-form-item>
                        </el-form>
                        
                    </el-card>
                </el-col>
            </el-row>
        </template>
		<template v-if="root_management === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>

		<el-dialog
		  :title="$t('edit')"
		  :visible.sync="dialogVisible"
		  :width="$store.state.isMobile? '90%' :'556px'"
		  :before-close="handleClose"
		>
		  <div class="add-template">
            <div slot="header" class="clearfix">
                <span style="font-weight:bold">{{$t('modifyInformation')}}</span>
            </div>
		    <el-form :model="form">
                        <el-form-item :label="item.label" v-for="item in formConfig" :key="item.prop">
                            <el-input v-model="form[item.prop]" clearable readonly="true"></el-input>
                        </el-form-item>
            </el-form>

            <div slot="header" class="clearfix">
                <span style="font-weight:bold">{{ $t('accessInfo') }}</span>
            </div>
            <el-form :model="form">
                <el-form-item :label="$t('accessAddress')"  >
                    <el-input  v-model="linkurl" clearable readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="Token"  >
                    <el-input v-model="linktoken"  clearable readonly="true"></el-input>
                </el-form-item>
            </el-form>
		</div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
		    <el-button type="primary" @click="changeInfo">{{
		      $t("Sure")
		    }}</el-button>
		  </span>
		</el-dialog>
	 
    </div>
</template>
<script>
import {changeUserinfo} from '@/api'
import userinfo from '@/mixins/userinfo'
export default {
    mixins : [userinfo],
    data() {
        return {
            root_management: '0',
			store_management: '0',
			exportcsv: '0',
			qyid: '',
            storeid:'',
			linkurl:'',
			linktoken:'mytokenhk',
            dialogVisible:false,
			url:'',
            formConfig: [
                {label: this.$t('CompanyName'), prop: 'name', type: 'input'},
                {label: this.$t('contactNumber'), prop: 'mobile', type: 'input'},
                {label: this.$t('contactAddress'), prop: 'address', type: 'input'},
                {label: this.$t('appid'), prop: 'appid', type: 'input'},
                {label: this.$t('appsecret'), prop: 'appsecret', type: 'input'},
                {label: this.$t('fromphone'), prop: 'fromphone', type: 'input'},
                {label: this.$t('access_token'), prop: 'access_token', type: 'input'}
            ],
            form: {
                name: '',appid:'',appsecret:'',fromphone:'',
                mobile: '',
                address: ''
            },
        }
    },
    created() {
     
        var user = JSON.parse(window.localStorage.getItem('user'))
		console.log('user:',user);
        var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        this.qyid = auser.qyid
        this.storeid = auser.storeid
        this.root_management = auser.root_management
        this.store_management = auser.store_management
        this.exportcsv = auser.exportcsv

        this.form.username = user.username
        this.form.password = user.password
        this.form.fromphone = user.fromphone
        this.form.appid = user.appid
        this.form.appsecret = user.appsecret
        this.getUserinfo()
    },
    watch: {
        userinfo(val) {
            console.log('val',val)
			this.url	 		 ='https://w9.nowaittech.com/app/index.php?i=1&c=entry&m=qicheng_messenger&do=shouquan_whatsapp&state='+val.id
            this.linkurl		 = 'https://w9.nowaittech.com/app/index.php?i=1&c=entry&m=qicheng_messenger&do=hook_new&qyid='+val.id 
			this.form.name 		 = val.name || ''
            this.form.contract   = val.contract || ''
            this.form.mobile     = val.mobile || ''
            this.form.address	 = val.address || ''
            this.form.qyid 		 = val.id
            this.form.appid 	 = val.appid
            this.form.fromphone  = val.fromphone
            this.form.appsecret  = val.appsecret
            this.form.access_token = val.access_token
        }
    },

    methods: {
        changeInfo() {
            if(this.form.name && this.form.mobile && this.form.address) {
                changeUserinfo(this.form).then(res => {
                    if(res.code == '1'){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.getUserinfo()
					 
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        })
                    }
                })
                this.dialogVisible=false;
            } else {
                this.$message({
                    message: this.$t('pleaseFillInTheInformation'),
                    type: 'warning'
                })
                this.dialogVisible=false;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.corporateInformation-wrapper {
    .btn{
        width: 80%;
        display: block;
        margin: 0 auto;
    }
}
</style>